$exceeded-color: #d03b3b;

//
//

.info {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 1rem 0;
  padding: 1rem;
  border-radius: 1rem;
  background-color: var(--tg-theme-secondary-bg-color);

  &__header {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;

    h2 {
      margin: 0;
      font-size: 1.1rem;
      font-weight: 600;
    }
  }

  &__goal {
    padding: 0.2rem 0.65rem;
    border-radius: 1rem;
    font-size: 0.8rem;
    white-space: nowrap;
    color: var(--tg-theme-subtitle-text-color);
    background-color: var(--tg-theme-bg-color);
  }

  &__nutrients {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  &__info {
    margin: 0;
    text-align: center;
    color: var(--tg-theme-subtitle-text-color);
  }

  &__error {
    margin: 0;
    text-align: center;
    color: var(--tg-theme-subtitle-text-color);
  }

  &__btn {
    width: 100%;
  }
}

//
//

.calories {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;

  &__numbers {
    display: flex;
    align-items: baseline;
    gap: 0.35rem;
  }

  &__consumed {
    font-size: 2.25rem;
    font-weight: 700;
    line-height: 1;
  }

  &__target {
    font-size: 0.95rem;
    color: var(--tg-theme-subtitle-text-color);
  }
}

//
//

.nutrient {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;

  &__info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.9rem;
  }

  &__name {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-weight: 500;
  }

  &__dot {
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
  }

  &__values {
    font-size: 0.85rem;
    color: var(--tg-theme-subtitle-text-color);
  }
}

//
//

.track {
  height: 0.4rem;
  border-radius: 0.25rem;
  overflow: hidden;
  background-color: var(--tg-theme-bg-color);

  &__fill {
    height: 100%;
    border-radius: 0.25rem;
  }
}

//
//

.status {
  align-self: flex-end;
  font-size: 0.8rem;
  color: var(--tg-theme-subtitle-text-color);

  &_exceeded {
    color: $exceeded-color;
    font-weight: 500;
  }
}
